import { createContext, ReactNode, useCallback, useContext, useMemo, useState } from 'react';

type BulkDecideContextType = {
  selectedTicketIds: string[];
  setSelectedTicketIds: (tickets: string[] | ((prevSelected: string[]) => string[])) => void;
  clearSelectedTicketIds: () => void;
  isBulkSelectMode: boolean;
  setIsBulkSelectMode: (value: boolean) => void;
};

const BulkDecideContext = createContext<BulkDecideContextType | undefined>(undefined);

export const BulkDecideProvider = ({ children }: { children: ReactNode }) => {
  const [selectedTicketIds, setSelectedTicketIds] = useState<string[]>([]);
  const [isBulkSelectMode, setIsBulkSelectMode] = useState(false);

  const clearSelectedTicketIds = useCallback(() => {
    setSelectedTicketIds([]);
  }, []);

  const value = useMemo(
    () => ({
      selectedTicketIds,
      setSelectedTicketIds,
      clearSelectedTicketIds,
      isBulkSelectMode,
      setIsBulkSelectMode,
    }),
    [selectedTicketIds, clearSelectedTicketIds, isBulkSelectMode]
  );

  return (
    <BulkDecideContext.Provider value={value}>
      {children}
    </BulkDecideContext.Provider>
  );
};

export const useBulkDecide = () => {
  const context = useContext(BulkDecideContext);
  if (context === undefined) {
    throw new Error('useBulkDecide must be used within a BulkDecideProvider');
  }
  return context;
};
